export default __webpack_public_path__ + "static/media/img1.6b2d8ca6.png";